import { SVGProps } from 'react'

const GovernanceIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.3342 18.5496L15.3257 18.558L15.3176 18.5668L12.3709 21.7815C12.1593 22.0123 11.798 22.0201 11.5765 21.7987L8.67035 18.8925L2.30914 12.2284C2.10285 12.0123 2.10681 11.671 2.31808 11.4597L11.6111 2.16673C11.8259 1.95194 12.1741 1.95194 12.3889 2.16673L21.664 11.4419C21.8788 11.6566 21.8788 12.0049 21.664 12.2197L15.3342 18.5496Z"
      stroke="currentColor"
      strokeWidth="1.1"
    />
    <path
      d="M16.0616 8.7002L9.96925 14.7925L7.93848 12.7617"
      stroke="currentColor"
      strokeWidth="1.1"
    />
  </svg>
)

export default GovernanceIcon
